/**
 * Содержимое внутренних страниц
 */
import { IPageContent, TPage, IPageLink } from '../../types/helper';

interface IInsidePages {
  [index: string]: IPageContent;
}

// tslint:disable:max-line-length
export const INSIDE_PAGE_CONTENT: IInsidePages = {
  start: {
    page: 'start' as TPage,
    title: 'С чего начать?',
    body: 'В этом этапе вы узнаете о том, как подготовить квартиру к продаже, какие документы понадобятся, как определить её стоимость, а также как составить идеальное объявление, чтобы быстрее найти покупателей.',
    links: [
      {
        name: 'Готовимся к сделке',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch1-gotovimsja-k-sdelke-287681/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch1-gotovimsja-k-sdelke-287681',
      },
      {
        name: 'Хоум-стэйджинг',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch-2-houm-stejdzhing-287784/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch-2-houm-stejdzhing-287784',
      },
      {
        name: 'Подготовка квартиры к фотосъемке',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch3-podgotovka-kvartiry-k-fotosemke-287785/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch3-podgotovka-kvartiry-k-fotosemke-287785',
      },
      {
        name: 'Оценка квартиры',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch4-otsenka-kvartiry-287786/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch4-otsenka-kvartiry-287786',
      },
      {
        name: 'Изучаем конкурентов',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch5-izuchaem-konkurentov-287861/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch5-izuchaem-konkurentov-287861',
      },
      {
        name: 'Пишем объявление о продаже квартиры',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch6-pishem-objavlenie-o-prodazhe-kvartiry-287863/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch6-pishem-objavlenie-o-prodazhe-kvartiry-287863',
      },
    ] as IPageLink[],
  },
  ad: {
    page: 'ad' as TPage,
    title: 'Подача объявления',
    body: 'Итак, вы определили стоимость квартиры, подготовили необходимые документы и сделали отличные фотографии. А что собственно дальше? Где размещать объявление? Сайты? Бумажные объявления? Социальные сети? В этом разделе мы расскажем вам какими каналами продажи стоит воспользоваться, а также дадим несколько советов по размещению объявления на ЦИАН.',
    links: [
      {
        name: 'Как выбрать площадку для публикации объявления?',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch7-kak-vybrat-ploschadku-dlja-publikatsii-objavlenija-287865/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch7-kak-vybrat-ploschadku-dlja-publikatsii-objavlenija-287865',
      },
      {
        name: 'Как подать объявление на ЦИАН',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch8-kak-podat-objavlenie-na-tsian-287945/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch8-kak-podat-objavlenie-na-tsian-287945',
      },
    ] as IPageLink[],
  },
  show: {
    page: 'show' as TPage,
    title: 'Звонки и показы',
    body: 'Если вы подумали, что самые сложные этапы уже пройдены, то спешим вас разочаровать — впереди вас ждет ещё длинный путь продажи, но не расстраивайтесь раньше времени, мы здесь чтобы помочь вам. В этом разделе вас ждут советы о том, как увеличить спрос на вашу квартиру, а также как эффективнее рассказывать и показывать вашу недвижимость.',
    links: [
      {
        name: 'Что делать, если нет звонков?',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch9-chto-delat-esli-net-zvonkov-287946/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch9-chto-delat-esli-net-zvonkov-287946',
      },
      {
        name: 'Звонки по объявлению, как разговаривать?',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch10-zvonki-po-objavleniju-kak-razgovarivat-287947/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch10-zvonki-po-objavleniju-kak-razgovarivat-287947',
      },
      {
        name: 'Что делать, если квартиру «не берут»?',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch11-chto-delat-esli-kvartiru-ne-berut-288008/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch11-chto-delat-esli-kvartiru-ne-berut-288008',
      },
      {
        name: 'Как проводить показы? Рациональные аспекты',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch13-kak-provodit-pokazy-ratsionalnye-aspekty-288594/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch13-kak-provodit-pokazy-ratsionalnye-aspekty-288594',
      },
      {
        name: 'Как проводить показы? Эмоциональные аспекты',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch14-kak-provodit-pokazy-emotsionalnye-aspekty-288641/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch14-kak-provodit-pokazy-emotsionalnye-aspekty-288641',
      },
    ] as IPageLink[],
  },
  'before-deal': {
    page: 'before-deal' as TPage,
    title: 'Подготовка к сделке',
    body: 'Поздравляем! Если вы дошли до этого этапа, похоже, что покупатель у вас уже есть. Но будьте бдительны — во время подготовки к сделке и самой сделки вас ждет много бумаг и договоров. Обязательно очень внимательно их читайте, ну а пока мы дадим вам несколько наших советов.',
    links: [
      {
        name: 'Аванс или задаток, что выбрать?',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch12-avans-ili-zadatok-chto-vybrat-288010/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch12-avans-ili-zadatok-chto-vybrat-288010',
      },
      {
        name: 'Готовим документы к сделке',
        url: 'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch15-gotovim-dokumenty-k-sdelke-288904/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch15-gotovim-dokumenty-k-sdelke-288904',
      },
    ] as IPageLink[],
  },
  deal: {
    page: 'deal' as TPage,
    title: 'Сделка',
    body: 'Продолжаем разбираться с документами и процессами, которые вам предстоит пройти в процессе продажи. Как правильно организовать сделку, как составить договор и передавать деньги, обо всем этом читайте ниже.',
    links: [
      {
        name: 'Взаимодействие с другими участниками сделки',
        url:  'https://www.cian.ru/stati-sekrety-uspeshnoj-prodazhi-ch16-vzaimodejstvie-s-drugimi-uchastnikami-sdelki-288914/',
        label: 'stati-sekrety-uspeshnoj-prodazhi-ch16-vzaimodejstvie-s-drugimi-uchastnikami-sdelki-288914',
      },
    ] as IPageLink[],
  },
  'after-deal': {
    page: 'after-deal' as TPage,
    title: 'После сделки',
    body: 'Ура! Ваша недвижимость продана, время для последнего рывка — как быть с налогами?',
    links: [
      {
        name: 'В процессе подготовки',
        url: 'about:blank',
        label: 'blank',
      },
    ] as IPageLink[],
  },
};
// tslint:enable:max-line-length
